<template>
  <div class="row-section" :style="cssVars">
    <div class="container" :class="containerClasses">
      <div class="row justify-content-around">
        <div class="col-md-5 img-wrapper" :class="{ 'order-md-2': flipImage }">
          <img
            v-lazy="imagePaths.mobile"
            class="d-block d-sm-none"
            :alt="altText"
          />
          <img
            v-lazy="imagePaths.desktop"
            class="d-none d-sm-block"
            :alt="altText"
          />
        </div>
        <div class="col-md-5 d-flex flex-column justify-content-md-center">
          <div class="content">
            <slot name="content"></slot>
          </div>
          <div class="row mx-0 below-text-content">
            <!-- <router-link to="/get-start" tag="button" class="cta">{{
              !!ctaButtonTitle ? ctaButtonTitle : "Apply Now"
            }}</router-link> -->
            <slot name="button-contact"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    backgroundPrimary: {
      type: String,
      default: "#ffffff",
    },
    backgroundSecondary: {
      type: String,
      default: "#ffffff",
    },
    imgSide: {
      type: String,
      required: true,
    },
    imageName: String,
    altText: String,
    ctaButtonTitle: String,
    displayCtaButton: {
     type: Boolean,
     default: true
    },
    containerClasses: String
  },
  computed: {
    flipImage: function () {
      return this.imgSide === "right";
    },
    cssVars: function () {
      return {
        "--background-primary-color": this.backgroundPrimary
          ? this.backgroundPrimary
          : "#ffffff",
        "--background-secondary-color": this.backgroundSecondary
          ? this.backgroundSecondary
          : "#ffffff",
        "--background-direction":
          this.imgSide === "to right" ? "to left" : "to right",
      };
    },
    imagePaths: function () {
      const mainDir = "/static/assets/imgs/";
      return {
        mobile: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}-mobile${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
        desktop: `${mainDir}${this.imageName.substring(
          0,
          this.imageName.lastIndexOf(".")
        )}${this.imageName.substring(this.imageName.lastIndexOf("."))}`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.row-section {
  background: linear-gradient(
    to bottom,
    var(--background-primary-color, #fff),
    var(--background-primary-color, #fff) 175px,
    var(--background-secondary-color, #fff) 175px,
    var(--background-secondary-color, #fff) 100%
  );
  @media (min-width: 768px) {
    background: linear-gradient(
      var(--background-direction, to right),
      var(--background-primary-color, #fff),
      var(--background-primary-color, #fff) 33%,
      var(--background-secondary-color, #fff) 33%,
      var(--background-secondary-color, #fff) 100%
    );
  }
}

.w-md-75 {
  @media (min-width: 768px) {
    width: 75%;
  }
}

.lei-section {
  .img-wrapper {
    @media (max-width: 767px) {
      order: 2;
      margin-top: 40px;
      margin-bottom: 0;
    }
  }
}

.img-wrapper {
  margin-bottom: 40px;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
}

.content {
  p {
    color: #666;
  }
}
.container {
  padding-top: 40px;
  padding-bottom: 40px;
  @media (min-width: 768px) {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  @media (min-width: 1200px) {
  }
}
h2 {
  font-size: 30px !important;
  font-weight: 900;
  margin: 0;
  margin-bottom: 20px;
  font-family: "Biotif", "Helvetica", sans-serif;

  @media (min-width: 768px) {
    font-size: 36px !important;
  }

  span {
    color: #5456ff;
    font-family: "Biotif", "Helvetica", sans-serif;
  }
}

p {
  margin-bottom: 0;
  font-weight: 600;
}
.cta {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 768px) {
    margin-left: 0;
    margin-right: 0;
  }
}

.below-text-content {
  margin-top: 40px;
}

img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;

  @media (max-width: 767px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// RowSection.vue?df9c4a72